"use client"
import { useTheme } from "@mui/material/styles"
import { FC } from "react"
import { useTranslation } from "react-i18next"

import styles from "./PostTeasersItem.module.scss"

import { PostTeaser, PostTeaserImage } from "@/components/common/post-teaser"

import { create } from "@/helpers/bem"
import { localizeDate } from "@/helpers/date"
import { resolveDarkModeAsset } from "@/helpers/theme"
import {
  Article,
  UploadFileEntityResponse,
} from "@/types/generated/strapi/graphql"
import type { Locale } from "@/utils/translations"

const bem = create(styles, "PostTeasersItem")

export type PostTeasersItemCover = UploadFileEntityResponse &
  Omit<PostTeaserImage, "src" | "alt">

export type PostTeasersItemProps = Omit<Article, "cover"> & {
  cover?: PostTeasersItemCover
  categorySlug: string
}

export const PostTeasersItem: FC<PostTeasersItemProps> = ({
  title,
  description,
  categorySlug,
  slug,
  readCount,
  cover,
  publishedAt,
}) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language
  const theme = useTheme()
  const dateFormated = localizeDate(locale as Locale, publishedAt)
  return (
    <PostTeaser
      className={bem()}
      content={description}
      date={dateFormated?.locale}
      metaDate={dateFormated?.meta}
      readCount={readCount ?? 0}
      image={
        cover
          ? {
              ...cover,
              src: resolveDarkModeAsset(theme, cover) ?? "",
              alt: cover?.data?.attributes?.alternativeText ?? "",
            }
          : undefined
      }
      redirect={{
        href: `${categorySlug}/${slug}` ?? "#",
        label: t("pages.views.postTeasers.postTeasersItem.link"),
      }}
      title={{
        content: title ?? "",
      }}
    />
  )
}
